<nav class="navbar navbar-expand-lg navbar-light">
  <div class="content-container" [class.container]="isDesktop">
    <div
      class="collapse navbar-collapse"
      id="navbarSupportedContent"
      [attr.data-bs-toggle]="bsToggle"
      [attr.data-bs-target]="bsTarget"
    >
      <div class="content">
        <ul class="navbar-nav me-auto mb-lg-0">
          <li class="nav-item">
            <a
              class="nav-link link-text internal-link first-item"
              [class.container]="!isDesktop"
              [class.active-link]="isMyAccountRoute"
              [routerLink]="[appRoutes.home.url]"
              routerLinkActive="active-link"
            >Página Inicial</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link link-text internal-link"
              [class.container]="!isDesktop"
              [routerLink]="[appRoutes.services.url]"
              routerLinkActive="active-link"
            >Serviços ao Segurado</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link link-text internal-link"
              [class.container]="!isDesktop"
              [routerLink]="[appRoutes.helpCenter.url]"
              routerLinkActive="active-link"
            >Perguntas Frequentes</a>
          </li>
        </ul>
        <div class="desktop-flex">
          <ul class="navbar-nav me-auto mb-lg-0" [class.container]="!isDesktop">
            <li class="nav-item last-nav-item">
              <a class="nav-link link-text last-item" target="_blank" [href]="siteInstitucionalLink">Site Institucional IPE Saúde</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nav>
